<template>
  <div>
      <transition name="fade">
            <div v-if="loadingPage" class="loading">
                <p>Loading...</p>
            </div>
        </transition>

    <b-container>
        <b-row>
            <b-col>
                <h4>Manage Brewery</h4>
            </b-col>
        </b-row>

        <!-- Select counties -->
        <b-card
            bg-variant="light" 
            border-variant="secondary"
            class="mb-2"
            header="Counties"
            header-tag="header"
            >
            <b-row>
                <b-col v-for="county in getCounties" :key="county.name">
                    <div v-if="county.isSelected" style="margin-bottom:5px">
                        <b-button :pressed="true" variant="warning" @click="removeCountyFromList(county.name)">{{county.name}} <font-awesome-icon icon="times" /></b-button>
                    </div>
                    <div v-else style="margin-bottom:5px">
                        <b-button variant="success" @click="addToCountyList(county.name)">{{county.name}} </b-button>
                    </div>
                </b-col>
            </b-row>

            
            <template #footer>
                <b-button style="margin-top:10px" variant="info" @click="updateCounties()" :disabled='!countiesUpdated'>Update Counties</b-button>
            </template>
        </b-card>

        <!-- Add beer -->
        <b-row>
            <b-col style="margin-top:20px">
                <b-button size="lg" block class="m-md-2" variant="info" @click="$router.push('selecttype')">
                    Add a Beverage
                </b-button>
            </b-col>
        </b-row>

        <template v-for="(item) in brewerInventory"> 
            <b-row :key="item.id">
                <b-col>
                    <Beerinventorycomponent :theOrigBeer="item" />
                </b-col>
            </b-row>
        </template>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

import Addinventorycomponent from '../Addinventorycomponent'
import Beerinventorycomponent from '../Beerinventorycomponent'

export default {    
    props: ['brewerId', 'distbrewerid'],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser']),

        //Counties
        getCounties(){
            this.allCounties=[]
            var arraySize = this.userProfile.counties.length
            for (var i = 0; i<arraySize; i++){
                var theCounty = {}
                
                theCounty.name = this.userProfile.counties[i]
                var existingCountyindex = -1
                //Check if county in counties list
                if(this.selectedCounties&&this.selectedCounties.length>0 ) existingCountyindex = this.selectedCounties.findIndex(item => item === theCounty.name);
                
                if (existingCountyindex > -1){
                    theCounty.isSelected = true
                } 
                else theCounty.isSelected = false

                this.allCounties.push(theCounty)
            }
            return this.allCounties
        },
    },

    components: {
        Beerinventorycomponent,
        Addinventorycomponent,
    },

    data() {
        return {
            brewerInventory:[],
            breweryProfile:{},
            loadingPage:false,

            //Counties
            allCounties:[],
            selectedCounties:[],
            countiesUpdated:false,
        }
    },

    methods:{

        //Get brewer profile
        getBrewerProfile(){

            fb.distributorBrewersCollection.where('distbrewerid', '==', this.distbrewerid).get().then(docs => {
                    docs.forEach(doc => {
                    this.breweryProfile = doc.data()
                    this.breweryProfile.docId = doc.id
                    console.log("Profile = ")
                    console.log(this.breweryProfile)
                    //Set counties
                    if(this.breweryProfile.counties&&this.breweryProfile.counties.length>0){
                        this.selectedCounties = this.breweryProfile.counties.slice(0)
                    }
                    //If no counties for brewery, use all of distributor's counties
                    else this.selectedCounties = this.userProfile.counties.slice(0)
                        
                    })
                }).then(res => {
                    this.getInventory()
                })
                .catch(err => {
                    console.log(err)
                    this.$store.commit('setDataLoadingInStoreStatus',false)
                    this.loadingPage=false
                })

        },

        //Get inventory for distributor brewery
        getInventory(){
            this.loadingPage=true
            var fbref = fb.beersCollection
            var brewerIdField = 'distbrewerid'
            var inventoryArray=[]

            fbref.where(brewerIdField, '==', this.distbrewerid).get().then(docs => {
                    docs.forEach(doc => {
                    var theBeer = doc.data()
                    theBeer.docId = doc.id
                    const existingBeerindex = inventoryArray.findIndex(item => item.docId === theBeer.docId );
                        if(existingBeerindex > -1){
                            inventoryArray.splice(existingBeerindex, 1, theBeer)
                        }
                        else {
                            inventoryArray.push(theBeer)
                        }
                        
                    })
                }).then(res => {
                    this.brewerInventory=inventoryArray
                    this.loadingPage=false
                })
                .catch(err => {
                    console.log(err)
                    this.$store.commit('setDataLoadingInStoreStatus',false)
                    this.loadingPage=false
                })
            
        },

        //Counties
        addToCountyList(countyName){
            this.selectedCounties.push(countyName)
            this.countiesUpdated=true

        },
        removeCountyFromList(countyName){
            var existingCountyindex = this.selectedCounties.findIndex(item => item === countyName);
            if (existingCountyindex > -1){
                this.selectedCounties.splice(existingCountyindex,1)
            }
            //Check min counties
            if(this.selectedCounties.length>0) this.countiesUpdated=true
            else this.countiesUpdated=false

        },
        //Update counties
        updateCounties(){
            
            fb.distributorBrewersCollection.doc(this.breweryProfile.docId).update({
                counties:this.selectedCounties,
            })
            this.$bvToast.toast('Counties Updated', {
                title: 'Counties Updated',
                solid:true,
                variant: 'success',
                autoHideDelay: 5000,
                appendToast: false
            })

        },
    },

    mounted(){
        if(this.distbrewerid) this.getBrewerProfile()
    },
}
</script>

